/**
 * Dashboard hero carousel — imagery aligned with pacisinsurance.com product pages.
 * Assets live in /public/images/hero/ (bundled with the portal, no external CDN dependency).
 */
import { CUSTOMER_PRODUCTS } from '@/constants/customerProducts';

/** @type {Record<string, string>} */
export const HERO_IMAGES = {
  motor: '/images/hero/motor.jpg',
  pa: '/images/hero/personal-accident.jpg',
  travel: '/images/hero/travel.jpg',
  amani: '/images/hero/travel.jpg',
  domestic: '/images/hero/domestic.jpg',
  brand: '/images/hero/brand-fallback.png',
};

const SLIDE_COPY = {
  motor: {
    eyebrow: 'Motor Insurance',
    title: 'Protect your vehicle and others',
    subtitle: 'Third party and comprehensive cover — drive with confidence.',
  },
  pa: {
    eyebrow: 'Personal Accident',
    title: 'Students PA — peace and comfort',
    subtitle: 'Accidental death, disability and medical benefits for students.',
  },
  travel: {
    eyebrow: 'Pacis Travel',
    title: 'Travel worry-free',
    subtitle: 'Local and international trip protection when you need it most.',
  },
  amani: {
    eyebrow: 'Pacis Amani Medical',
    title: 'Healthcare for you and family',
    subtitle: 'Inpatient and outpatient medical cover tailored to your needs.',
  },
  domestic: {
    eyebrow: 'Domestic Package',
    title: 'Protect your home and contents',
    subtitle: 'Buildings, contents and domestic workers under one policy.',
  },
};

/**
 * Live product slides for the dashboard hero (excludes welcome-only entries).
 */
export function buildDashboardHeroSlides() {
  return CUSTOMER_PRODUCTS
    .filter((p) => (p.live || p.hero) && p.id !== 'sme' && SLIDE_COPY[p.id])
    .map((product) => ({
      id: product.id,
      eyebrow: SLIDE_COPY[product.id].eyebrow,
      title: SLIDE_COPY[product.id].title,
      subtitle: SLIDE_COPY[product.id].subtitle,
      image: HERO_IMAGES[product.id] || HERO_IMAGES.brand,
      ctaLabel: 'Buy now',
      route: product.route || { name: 'CustomerProductSelect' },
      accent: product.accent,
    }));
}
